import { render, staticRenderFns } from "./BoostEndedIcon.vue?vue&type=template&id=1613a646&scoped=true"
import script from "./BoostEndedIcon.vue?vue&type=script&lang=js"
export * from "./BoostEndedIcon.vue?vue&type=script&lang=js"
import style0 from "./BoostEndedIcon.vue?vue&type=style&index=0&id=1613a646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1613a646",
  null
  
)

export default component.exports